import IconSvg from "./IconSvg";

export const IncompleteStudentsModal = ({ isOpen, onClose, students }) => {
    if (!isOpen) return null;
    const handleOutsideClick = (e) => {
        if (e.target.className === "modal-overlay") {
            onClose();
        }
    };
    const getPersonalityStatus = (student)=>{
        const parsedQuestions = student.que && !["null", undefined].includes(student.que) ? JSON.parse(student.que) : [];
        const parsedAnswers = student.ans && !["null", undefined].includes(student.ans) ? JSON.parse(student.ans) : {};
        const evalQuestions = Array.isArray(parsedQuestions) ? parsedQuestions: JSON.parse(parsedQuestions);
        const isPersonalityCompleted = (evalQuestions && evalQuestions[0]?.topic && evalQuestions.length === Object.values(parsedAnswers).filter(Boolean).length);
        return isPersonalityCompleted ? "Completed" : "Not Completed";
    }
    return (
        <div className="modal-overlay" onClick={handleOutsideClick}>
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="modal-content">
          <div
            style={{
              padding: "1.6rem",
              borderBottom: "1px solid var(--color-gray-200)",
            }}
          >
            <div className="flex justify-between items-center">
              <h3 className="modal-header-title">Students With Incomplete Reports</h3>
              <button onClick={onClose} className="modal-close-button">
                <IconSvg path="M6 18L18 6M6 6l12 12" className="h-6 w-6" />
              </button>
            </div>
          </div>
          <div className="modal-body">
            <div className="modal-table-container">
              <table className="modal-table">
                <thead className="modal-table thead">
                  <tr>
                    <th
                      scope="col"
                      className="cursor-pointer"
                    >
                      Student Name
                    </th>
                    <th
                      scope="col"
                      className="cursor-pointer"
                    >
                      Profile
                    </th>
                    <th
                      scope="col"
                      // className="cursor-pointer"
                    >
                      Personality
                    </th>
                    <th scope="col" style={{ textAlign: "right" }}>
                      Exam
                    </th>
                  </tr>
                </thead>
                <tbody className="student-list">
                  {students.length > 0 ? (
                    students.map((student) => (
                      <tr key={student.user_id}>
                        <td className="flex items-center">
                          <div className="student-list-item-profile">
                            {student.url ? (
                              <img
                                src={student.url}
                                alt={`${student.first_name} ${student.last_name}`}
                                className="outlier-profile-pic"
                              />
                            ) : (
                              <div className="outlier-profile-pic-placeholder">
                                {student.first_name?.charAt(0)?.toUpperCase()}
                              </div>
                            )}
                          </div>
                          {student.first_name || ""} {student.last_name || ""}
                        </td>
                        <td>
                          <span
                            className={`score-badge}`}
                          >
                            {student.profile_status || "Data Visualization"}
                          </span>
                        </td>
                        <td>{getPersonalityStatus(student) || "Not Completed"}</td>
                        <td className="text-right cursor-pointer">
                          <span>{student.exam_status}</span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center text-gray-500">
                        No students found matching your search.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
  
          <div className="modal-footer">
            <button onClick={onClose} className="modal-footer-button">
              Close
            </button>
          </div>
        </div>
      </div>
    );
};